import { render, staticRenderFns } from "./BaseCity.vue?vue&type=template&id=5abbbdc3&scoped=true&"
import script from "./BaseCity.vue?vue&type=script&lang=js&"
export * from "./BaseCity.vue?vue&type=script&lang=js&"
import style0 from "./BaseCity.vue?vue&type=style&index=0&id=5abbbdc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abbbdc3",
  null
  
)

export default component.exports